import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { PosConfigController } from './pos-config.controller';
import { PosConfigService } from './pos-config.service';

@Module({
  imports: [PrismaModule],
  controllers: [PosConfigController],
  providers: [PosConfigService],
  exports: [PosConfigService],
})
export class PosConfigModule {}
